export default __webpack_public_path__ + "static/media/landingVideoScreen.5713987c.jpg";